import { c as _c } from "react/compiler-runtime";
import { Flag, Tooltip } from 'platform/components';
import { HStack } from 'platform/foundation-tw';
import { isNil } from 'ramda';
import { isArray } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getItemTooltipProps } from '../../utils/getItemTooltipProps';
import { getTooltipProps } from '../../utils/getTooltipProps';

// Whole raw API cell shape for ENUM+FLAG columns (getValueFromRawCell returns this unchanged)
type FlagItem = {
  label: string;
  key?: string;
};
type FlagRawCell = {
  value: FlagItem | FlagItem[] | null;
  style?: {
    flagColor?: string;
    flagSubtle?: boolean;
  };
  id?: string;
} | null;
type FlagCellRendererProps = CellRendererProps<FlagRawCell> & {
  getTooltipProps?: TooltipGetter;
};
export function FlagCellRenderer(props) {
  const $ = _c(15);
  let T0;
  let t0;
  let t1;
  let t2;
  if ($[0] !== props.getTooltipProps || $[1] !== props.row || $[2] !== props.value) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
      if (isNil(props.value)) {
        t2 = null;
        break bb0;
      }
      const raw = props.value;
      const flagColor = raw?.style?.flagColor;
      const flagIsSubtle = raw?.style?.flagSubtle ?? false;
      const cellValue = raw?.value;
      if (isNil(cellValue)) {
        t2 = null;
        break bb0;
      }
      if (!isArray(cellValue)) {
        const t3 = flagColor as never;
        let t4;
        if ($[7] !== cellValue.label || $[8] !== flagIsSubtle || $[9] !== t3) {
          t4 = <Flag colorScheme={t3} isSubtle={flagIsSubtle} label={cellValue.label} />;
          $[7] = cellValue.label;
          $[8] = flagIsSubtle;
          $[9] = t3;
          $[10] = t4;
        } else {
          t4 = $[10];
        }
        t2 = <Tooltip {...tooltipProps}>{t4}</Tooltip>;
        break bb0;
      }
      T0 = HStack;
      t0 = 2;
      t1 = cellValue.map((item, index) => {
        if (isNil(item)) {
          return null;
        }
        return <Tooltip key={`${item.label}-${index}`} {...getItemTooltipProps(index, tooltipProps)}><Flag colorScheme={flagColor as never} isSubtle={flagIsSubtle} label={item.label} /></Tooltip>;
      });
    }
    $[0] = props.getTooltipProps;
    $[1] = props.row;
    $[2] = props.value;
    $[3] = T0;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    T0 = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[11] !== T0 || $[12] !== t0 || $[13] !== t1) {
    t3 = <T0 spacing={t0}>{t1}</T0>;
    $[11] = T0;
    $[12] = t0;
    $[13] = t1;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}